import { Routes, Route } from 'react-router-dom';
import { Home } from '../pages/Home';
import { About } from '../pages/About';
import { JeansCollection } from '../pages/JeansCollection';
import { Contact } from '../pages/Contact';
import { PrivacyPolicy } from '../pages/PrivacyPolicy';
import { TermsService } from '../pages/TermsService';
import { NotFound } from '../pages/404';

import { Layout } from '../component/Layout';

export const PageRouter = () => {
    return (
        <Routes>
            {/* Normal routes */}
            <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/womens-jeans" element={<JeansCollection />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" element={<TermsService />} />
            </Route>
            {/* 404 Page WITHOUT Header and Footer */}
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};